module.exports = __webpack_public_path__ + "media/images/pearle-hover 2-8f09f4959f792ba7e99c97c68ee1d68d.png";